import { useEffect } from 'react';

function useDocumentTitle(title, prevailOnUnmount = false) {
    const pageTitle = title ? `${title} | DiviUp` : 'DiviUp';

    useEffect(() => {
        document.title = pageTitle;
    }, [title]);

    useEffect(
        () => () => {
            if (!prevailOnUnmount) {
                document.title = 'DiviUp';
            }
        },
        []
    );
}

export default useDocumentTitle;
